import React from 'react';

import { PrismicRichText } from 'types/prismicRichtext';

import { asText, RichText } from 'components/rich-text/RichText';
import { Tabs, ITabs } from 'components/tabs/Tabs';
import { ExcludesNull } from 'types/excludesNull';
import { PrismicTabsFields } from 'types/prismicSlices';

interface ITabsContainer {
  title?: PrismicRichText;
  items: PrismicTabsFields[];
  isColumnLayout?: boolean;
}

export const TabsContainer = ({ title, items, isColumnLayout = false }: ITabsContainer) => {
  if (items.length === 0) {
    return null;
  }

  const tabs: ITabs[] = items
    .map((item: PrismicTabsFields) => {
      if (!item.tab_title || !item.tab_content) {
        return null;
      }

      const tabTitle = asText(item.tab_title);
      const content = <RichText>{item.tab_content}</RichText>;

      return { title: tabTitle, content };
    })
    .filter((Boolean as any) as ExcludesNull);

  return <Tabs title={title ? asText(title) : undefined} tabs={tabs} />;
};
